class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
    this.bindEvents();
  }

  initSwiper() {
        this.progressLine = document.querySelector('.cart-drawer__upsell-line');

    this.swiper = new Swiper('.cart-upsell-swiper', {
      slidesPerView: 2.2,
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      on: {
        slideChange: (swiper) => {
          if (this.progressLine) {
            const progress = swiper.progress;
            this.progressLine.style.setProperty('--swiper-progress', progress);
          }
        }
      }
    });
  }

  bindEvents() {
    this.querySelectorAll('.cart-upsell-add').forEach(button => {
      button.addEventListener('click', this.handleAddToCart.bind(this));
    });
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    const productId = button.dataset.productId;

    if (button.disabled) return;

    // Disable button and show loading state
    button.disabled = true;
    button.classList.add('loading');

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
          sections: ['cart-drawer']
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Update cart drawer contents
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
          cartDrawerElement.renderContents(data);
        }
      } else {
        console.error('Error adding product to cart:', data);
      }
    } catch (error) {
      console.error('Error adding product to cart:', error);
    } finally {
      // Re-enable button and remove loading state
      button.disabled = false;
      button.classList.remove('loading');
    }
  }
}

customElements.define('cart-drawer-upsell', CartDrawerUpsell); 